import { RingLoader, BarLoader } from 'react-spinners';

export default function LoadingOverlay() {
    return (
        <div className="h-full w-full bg-white/80 fixed z-[99] flex items-center justify-center">
            <BarLoader 
                color={'#7d5af6'}
                loading={true}
                size={10}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}